import { useAppSelector } from '../../../../hooks/redux'
import { RoutesPath } from '../../../../constants/RoutesPath'
import { Strings } from '../../../../constants/Strings'
import NavBarItem from "./NavBarItem/NavBarItem"

const NavBar = () => {
    
    const language = useAppSelector<string>(state => state.language.language)

    return (
        <nav>
            <NavBarItem
                to={RoutesPath.privacyPolicyProfile + '/remove-data'}
                icon={"fas fa-trash"}
                title={Strings[language ?? 'tm'].profileDataTrash}
                count={null}
            />
            <NavBarItem
                to={RoutesPath.privacyPolicyProfile + '/trash'}
                icon={"fas fa-trash"}
                title={Strings[language ?? 'tm'].profileTrash}
                count={null}
            />
        </nav>
    )
}

export default NavBar
